import {
  Box,
  Button,
  Grid,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useState } from "react";
import TrendzContainerCard from "../../../components/TrendzContainerCard";

export function SettingGeneralPage() {
  const { t } = useTranslation(["common", "social", "settings", "tutorial"]);
  const [activeStep, setActiveStep] = useState(0);
  const steps = [
    {
      label: t("tutorial:follow_keyword_clusters"),
      description: t("tutorial:keyword_cluster_description"),
      url: "/specialization/cluster",
    },
    {
      label: t("tutorial:follow_domains"),
      description: t("tutorial:keyword_cluster_description"),
      url: "/settings/domain",
    },
    {
      label: t("tutorial:follow_touch_points"),
      description: t("tutorial:keyword_cluster_description"),
      url: "/social-network/google",
    },
    {
      label: t("tutorial:setup_alerts"),
      description: t("tutorial:alert_description"),
      url: "/settings/alert",
    },
  ];

  return (
    <TrendzContainerCard title={t("common:general")}>
      <Grid item xs={0.75} />
      <Grid item xs={5} className="white">
        <Stepper
          style={{ padding: 8 }}
          className="white"
          activeStep={activeStep}
          orientation="vertical"
        >
          {steps.map((label, index) => (
            <Step key={label["label"]}>
              <StepLabel
                className="step-label"
                onClick={() => setActiveStep(index)}
              >
                {label["label"]}
              </StepLabel>
              <StepContent style={{ textAlign: "left" }}>
                <Typography textAlign={"left"}>
                  {label["description"].length > 0 ? label["description"] : ""}
                </Typography>
                <Box sx={{ marginLeft: "auto" }}>
                  <div>
                    <Link to={label.url}>
                      <Button variant="contained" sx={{ mt: 1, mr: 1 }}>
                        {t("common:setup_now")}
                      </Button>
                    </Link>
                  </div>
                </Box>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Grid>
    </TrendzContainerCard>
  );
}
